import i18n from '@assets/i18n/index';
import PtMessageBox from '@ui/message-box';
import PtButton from '@uiv1/components/button';
import PtIcon from '@uiv1/components/icon';
import { Profile } from '@models/profile/profileList';
import { Product } from '@models/profile/useCurrentProfile';
import useActiveProduct from '@master/hooks/service/useActiveProduct/useActiveProduct';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import { checkModuleAvailabilityForRole } from '@/hooks/useRole';
import styles from '@/pages/master/hooks/service/usePlanLimit/index.module.scss';

export default function useShowAuthDialog() {
    const { activeConfirm } = useActiveProduct();

    const checkAuth = function (
        product: Product,
        profile: Profile,
        callBack?: () => void,
        noAuthCallBack?: () => void
    ) {
        if (!product?.key) {
            return;
        }

        const mapping = {
            insight: ['insight', 'enableInsight'],
            experience: ['experience', 'enableExperience'],
            landing_page: ['pageStudio', 'enablePageStudio']
        };
        const hasRole =
            product.key === 'experience' && profile.isVirtual //虚拟档案不允许进入experience
                ? false
                : checkModuleAvailabilityForRole(
                      mapping[product.key][0] as any,
                      mapping[product.key][1],
                      profile.userRole
                  );
        const active = profile[product.activeKey];

        if (active) {
            if (hasRole) {
                callBack?.();
            } else if (noAuthCallBack) {
                noAuthCallBack();
            } else {
                PtMessageBox({
                    showCancelButton: false,
                    showConfirmButton: false,
                    title: 'Confirmation',
                    customClass: styles.small,
                    message: (
                        <>
                            <div class={styles.container}>
                                <p class={styles.title}>
                                    <PtIcon icon="pt-icon--warn" />
                                    {i18n?.global?.t('common.change_profile_permission_title', {
                                        product: product.name
                                    })}
                                </p>
                                <p class={styles.desc}>
                                    {i18n?.global?.t('common.change_profile_permission_01', {
                                        product: product.name
                                    }) +
                                        profile.name +
                                        i18n?.global?.t('common.change_profile_permission_02') +
                                        profile.ownerEmail +
                                        i18n?.global?.t('common.change_profile_permission_03')}
                                </p>
                                <div class={styles.btnArea}>
                                    <PtButton
                                        type="outline"
                                        color="darkblue"
                                        onClick={() => {
                                            const overlay = document.querySelector(
                                                `.${styles.small}`
                                            );
                                            const closeBtn = overlay?.querySelector(
                                                '.pt-message-box__headerbtn'
                                            ) as HTMLButtonElement;
                                            closeBtn?.click?.();
                                        }}
                                    >
                                        {/* linlin说文案不大合适 */}
                                        {i18n?.global?.t('common.got_it')}
                                    </PtButton>
                                </div>
                            </div>
                        </>
                    )
                })
                    .then(() => {})
                    .catch(() => {});
            }
        } else {
            activeConfirm(profile.sid, product.key);
        }
    };
    return { checkAuth };
}

export function useRoleDialog(subModule: string): boolean {
    const { profileInfo, validateModule } = useProfileInfo();
    const hasRole = validateModule('experience', subModule as any);

    if (!hasRole) {
        PtMessageBox({
            showCancelButton: false,
            showConfirmButton: false,
            title: 'Confirmation',
            customClass: styles.small,
            message: (
                <>
                    <div class={styles.container}>
                        <p class={styles.title}>
                            <PtIcon icon="pt-icon--warn" />
                            {i18n?.global?.t('experience.message.no_create_access_title')}
                        </p>
                        <p class={styles.desc}>
                            {i18n?.global?.t('experience.message.no_create_access_tips', {
                                owner: profileInfo.value?.ownerEmail
                            })}
                        </p>
                        <div class={styles.btnArea}>
                            <PtButton
                                type="outline"
                                color="darkblue"
                                onClick={() => {
                                    const overlay = document.querySelector(`.${styles.small}`);
                                    const closeBtn = overlay?.querySelector(
                                        '.pt-message-box__headerbtn'
                                    ) as HTMLButtonElement;
                                    closeBtn?.click?.();
                                }}
                            >
                                {/* linlin说文案不大合适 */}
                                {i18n?.global?.t('onboTip.got_it')}
                            </PtButton>
                        </div>
                    </div>
                </>
            )
        })
            .then(() => {})
            .catch(() => {});
        return false;
    }
    return true;
}
